module.exports = __webpack_public_path__ + "img/logo.48c19c7a.png";